import { useSelector } from 'react-redux';
// @ts-expect-error not typed
import GlobalContentModal from 'ContentEditorUI/components/modals/GlobalContentModal';
// @ts-expect-error not typed
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { getOpenModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
// @ts-expect-error not typed
import NotificationList from 'ReduxMessenger/components/NotificationList';
import AutoSave from '../../components/AutoSave';
import { SETTINGS_MODAL } from '../../constants';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { useEffect, useRef } from 'react';
import { usageTracker } from '../../utils/usageTracker';
import { ONBOARDING_MODAL, OnboardingModal, OnboardingTourController } from './OnboardingTour';
import ScaffoldingContainer from '../containers/ScaffoldingContainer';
import { useQueryParams } from 'ContentEditorUI/utils/routingUtils';
// @ts-expect-error module not typed
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
import enviro from 'enviro';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncSettingsModal = makeAsyncComponent(() => import( /* webpackChunkName: 'AsyncSettingsModal' */'./SettingsModal'));
const ModalSwitch = ({
  openModal
}) => {
  switch (openModal) {
    case SETTINGS_MODAL:
      return /*#__PURE__*/_jsx(AsyncSettingsModal, {});
    case ONBOARDING_MODAL:
      return /*#__PURE__*/_jsx(OnboardingModal, {});
    default:
      return null;
  }
};
const AGENT_SURVEY_ID = {
  QA: 436,
  PROD: 1182
};
const NO_AGENT_SURVEY_ID = {
  QA: 446,
  PROD: 1197
};
export const useFeedbackSurvey = () => {
  const {
    generatedByAI = false
  } = useQueryParams();
  const hasSurveyRendered = useRef(false);
  const {
    config,
    renderSurvey,
    clientLoaded,
    loadConfigOnly
  } = useFeedbackLoader();
  useEffect(() => {
    if (clientLoaded && !config) {
      if (generatedByAI) {
        loadConfigOnly(enviro.isQa() ? AGENT_SURVEY_ID.QA : AGENT_SURVEY_ID.PROD, 'CSAT');
      } else {
        loadConfigOnly(enviro.isQa() ? NO_AGENT_SURVEY_ID.QA : NO_AGENT_SURVEY_ID.PROD, 'CSAT');
      }
    }
  }, [clientLoaded, config, generatedByAI, loadConfigOnly]);
  useEffect(() => {
    if (hasSurveyRendered.current || !config) {
      return;
    }
    renderSurvey();
    hasSurveyRendered.current = true;
  }, [clientLoaded, config, generatedByAI, renderSurvey]);
};
const ExtraApplicationContainerComponents = () => {
  const openModal = useSelector(getOpenModal);
  useEffect(() => {
    UsageTracker.init(usageTracker, 'case-study-editor-ui');
    UsageTracker.track('pageView');
  }, []);
  useFeedbackSurvey();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AutoSave, {}), /*#__PURE__*/_jsx(GlobalContentModal, {}), /*#__PURE__*/_jsx(ModalSwitch, {
      openModal: openModal
    }), /*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(OnboardingTourController, {}), /*#__PURE__*/_jsx(ScaffoldingContainer, {})]
  });
};
export default ExtraApplicationContainerComponents;